import { functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";

const call = (name) => httpsCallable(functions, name);

/** Player → server: seconds actually played (paying members only; the server re-checks everything). */
export const reportListening = (trackId, seconds) => call("reportListening")({ trackId, seconds }).then((r) => r.data);

export const getPoolEarnings = () => call("getPoolEarnings")({}).then((r) => r.data);
export const cashOutPoolEarnings = () => call("cashOutPoolEarnings")({}).then((r) => r.data);

export const monthLabel = (id) => {
  if (!id) return "";
  const [y, m] = id.split("-").map(Number);
  return new Date(Date.UTC(y, m - 1, 1)).toLocaleString(undefined, { month: "long", year: "numeric", timeZone: "UTC" });
};